const requestAdditionalDataBaseUrl = 'api/request-additional-data';

const ApiConfigs = {
  baseUrls: {
    userInfo: 'api/UserInfo',
    statistics: 'api/statistics',
    requestAdditionalData: requestAdditionalDataBaseUrl,
    dataTypes: `${requestAdditionalDataBaseUrl}/data-types`,
    verifyAccountInfo: `${requestAdditionalDataBaseUrl}/verify-account`,
  },
};

export {
  ApiConfigs,
};
